import * as React from "react";
import { useAtom } from "jotai";

import { authenticationAtom } from "@/State";
import { userAPI } from "@/UserAPI";

/**
 * Foto des angemeldeten Nutzers. Das Login-Ergebnis führt kein Foto mit; der
 * eigene Datensatz wird aus der Nutzerliste des Tenants nachgeladen (der
 * generische Entity-Endpunkt gibt User nicht heraus). Ohne Foto oder bei
 * Fehlern bleibt null (Initialen-Fallback).
 */
export function useUserPhoto() {
  const [authentication] = useAtom(authenticationAtom) as any;
  const [userPhoto, setUserPhoto] = React.useState<string | null>(null);

  React.useEffect(() => {
    const userId = authentication?.id;
    const email = authentication?.email;
    if (!userId && !email) {
      setUserPhoto(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const users: any[] = await (userAPI as any).getUsers();
        const self = (Array.isArray(users) ? users : []).find(
          (user: any) => user?.id === userId || user?._id === userId || user?.email === email,
        );
        if (!cancelled) {
          // photo ist der S3-Key (z. B. "<tenant>/userPhoto…jpeg"); ausgeliefert
          // wird er über die /documents-Route des Servers (vgl. PUT
          // /users/:user/photo, das genau diesen Pfad zurückgibt).
          setUserPhoto(
            self?.photo
              ? userAPI.getResourceURL(`/documents/${self.photo}`)
              : null,
          );
        }
      } catch {
        // Initialen-Fallback genügt.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authentication?.id, authentication?.email]);

  return userPhoto;
}
